export default {
  navbarLeft: [
    {
      name: 'About',
      href: '/#about',
    },
    {
      name: 'Prizes',
      href: '/prizes',
    },
    {
      name: 'Get ready',
      href: '/get-ready',
    },
    {
      name: 'FAQ',
      href: '/faq',
    },
  ],
}
